import { useState } from "react";

export const faqs = [
  {
    question: "Peut-on réparer un moteur Nice ou faut-il le changer ?",
    answer: "Les moteurs Nice sont conçus pour durer, et une grande partie des pannes ne nécessite pas de remplacement. Le récepteur radio OXIBD peut perdre sa programmation, l'émetteur mural peut subir une oxydation des contacts, ou le condensateur de démarrage peut s'user. Ces trois problèmes se règlent par réparation en moins de quarante minutes. Si le moteur tubulaire est grippé, brûlé ou si son enroulement est endommagé, le remplacement est alors la seule issue. Notre diagnostic gratuit identifie précisément la cause.",
  },
  {
    question: "Quel est le prix d'un remplacement de moteur Nice ?",
    answer: "Le prix dépend du modèle de moteur choisi (filaire ou radio OXIBD), de la dimension du volet et du poids du tablier. Les moteurs Nice sont légèrement moins chers que les Somfy io, mais leur robustesse les rend particulièrement adaptés aux grandes baies vitrées et aux volets lourds. Nous vous établissons un devis gratuit sur place qui inclut le moteur, la pose, le recâblage, la reprogrammation des télécommandes et émetteurs, et la garantie décennale.",
  },
  {
    question: "Combien de temps dure l'intervention de remplacement ?",
    answer: "Un remplacement de moteur Nice dure généralement entre 45 minutes et 1 heure 15. Les moteurs filaires avec interrupteur mural se remplacent rapidement. Les moteurs radio avec récepteur intégré demandent un temps supplémentaire pour l'appairage des émetteurs et la vérification du signal. Nous intervenons avec les pièces en stock pour faire l'installation en une seule visite. L'intervention se termine par des tests de montée, descente et arrêt d'urgence.",
  },
  {
    question: "Gardez-vous mes télécommandes et commandes existantes ?",
    answer: "Oui, dans la plupart des cas. Les télécommandes Nice et les émetteurs muraux sont compatibles avec les moteurs de remplacement de la même génération. Nous réinitialisons le récepteur radio et appairons à nouveau vos émetteurs existants. Si vous avez un système domotique intégrant des volets Nice, nous resynchronisons le moteur avec votre installation. Si vos commandes sont trop anciennes ou incompatibles, nous vous proposons des remplacements adaptés à votre système.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-[#F4F8FB] py-14 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <h2 className="text-[#143A66] text-2xl md:text-3xl font-extrabold text-center mb-3">
          Questions fréquentes
        </h2>
        <p className="text-[#2F4A63] text-base text-center mb-10 md:mb-14">
          Tout ce que vous devez savoir sur le remplacement de moteur Nice.
        </p>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl border border-[#E2E8F0] overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer"
              >
                <span className="text-[#143A66] font-semibold text-base pr-4">
                  {faq.question}
                </span>
                <span className="w-8 h-8 flex items-center justify-center shrink-0 rounded-full bg-[#00B3A4]/10">
                  <i
                    className={`ri-arrow-down-s-line text-[#00B3A4] text-lg transition-transform ${openIndex === index ? "rotate-180" : ""}`}
                  ></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5 md:px-6 md:pb-6">
                  <p className="text-[#2F4A63] text-base leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}